const theme = {
  colors: {
    primary: '#0A1929',       /* Deep navy blue background */
    secondary: '#132F4C',     /* Slightly lighter blue */
    accent: '#1E88E5',        /* Vibrant blue accent */
    background: '#0A1929',    /* Deep navy blue background */
    darkBg: '#132F4C',        /* Slightly lighter blue */
    text: '#F0F7FF',          /* Ice blue text */
    textLight: '#F0F7FF',     /* Ice blue text */
    textSecondary: '#B2BAC2',  /* Muted blue-gray text */
    success: '#4CAF50',       /* Green success */
    warning: '#FF9800',       /* Orange warning */
    danger: '#F44336',        /* Red danger */
    shadow: 'rgba(0, 10, 30, 0.7)', /* Deep blue shadow */
    gray: {
      100: '#F0F7FF',
      200: '#D9E3F0',
      300: '#C7D0DE',
      400: '#B2BAC2',
      500: '#9DA8B7',
      600: '#6B778C',
      700: '#495366',
      800: '#2D3A4F',
      900: '#1A2133',
    }
  },
  fonts: {
    main: "'Poppins', sans-serif",
    secondary: "'Roboto', sans-serif"
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 6px rgba(0, 0, 0, 0.1)',
    large: '0 10px 15px rgba(0, 0, 0, 0.1)',
    xl: '0 15px 30px rgba(0, 0, 0, 0.1)'
  },
  transitions: {
    default: 'all 0.3s ease',
    slow: 'all 0.6s ease',
    fast: 'all 0.1s ease'
  },
  radius: {
    small: '4px',
    default: '8px',
    large: '16px',
    round: '50%'
  },
  breakpoints: {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  }
};

export default theme;
